var _defs, _path, _path2, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodoidLogo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 841.89 595.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{font-size:167px;font-family:Avenir-Heavy, \"Avenir 85 Heavy\";font-weight:800;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.68,213.05l-56,25.8c-11.36-18.36-27.18-30.81-48-36.42a76.36,76.36,0,0,0-48,2.45c-31.16,11.81-53.58,42.79-51.19,80.33a79.37,79.37,0,0,0,56.81,71.31,76.18,76.18,0,0,0,54.28-3.65c17.55-7.86,30.44-20.71,39.2-38.06,18,10,35.91,19.88,54.12,30-2.57,4.31-4.88,8.58-7.54,12.62C269.16,388,241.45,408.15,206,417.57a134,134,0,0,1-42.34,4.1c-28.24-1.67-53.86-10.89-76.37-28.08q-41.65-31.74-53.22-83.06A136.62,136.62,0,0,1,31,271.93c1.8-30,11.8-57.09,30.56-80.73A139,139,0,0,1,136.9,142a131.37,131.37,0,0,1,42.32-4.13c40.07,2.66,73.22,19.4,99.45,49.83a134.8,134.8,0,0,1,16.26,23.78c.24.42.42.87.75,1.56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.38,239.45c9.2,31.48,18.32,62.83,27.49,94.26-6.33-.81-106.49-50.14-109.12-53.7,1.92-2.26,70.56-36.39,81.63-40.56"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(344.8 346.81)"
  }, "odoid")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodoidLogo01);
export default __webpack_public_path__ + "static/media/Codoid-Logo-01.cd10e031cc529365cc7b7200e0b63b17.svg";
export { ForwardRef as ReactComponent };